import { cloudStorage } from "@tma.js/sdk-react";
import invariant from "tiny-invariant";

export const getCloudStorage = () => {
  invariant(
    cloudStorage.isSupported,
    "Current telegram mini app version doesn't support cloudStorage"
  );
  invariant(
    cloudStorage.getItem.isAvailable(),
    "cloudStorage.getItem is not available"
  );
  invariant(
    cloudStorage.setItem.isAvailable(),
    "cloudStorage.setItem is not available"
  );

  return cloudStorage;
};
